import React, { useState } from 'react';
import { message } from 'antd';
import { StyledModal, StyledLink, StyledButton, Heading } from './styled';
import FileUpload from './components/FileUpload';
import { sendDriverInvoicingRequest } from './logic';
import ModalLoadingOverlay from '$app/shared/components/ModalLoadingOverlay';
import SuccessModal from './components/SuccessModal';
import config from '$config';
import ErrorContainer from './components/ErrorContainer';

const InvoicingModal = () => {
  const [showInvoicingModal, setShowInvoicingModal] = useState(false);
  const [fileList, setFileList] = useState(null);
  const [apiPayload, setApiPayload] = useState(null);
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [successModalVisible, setSuccessModalVisible] = useState(false);

  const onCancel = () => setShowInvoicingModal(false);

  const InvoicingLink = () => <StyledLink onClick={() => setShowInvoicingModal(true)}>Invoicing</StyledLink>;

  const sendInvoices = async () => {
    try {
      setIsLoading(true);
      sendDriverInvoicingRequest(apiPayload);
      setIsLoading(false);
      setSuccessModalVisible(true);
      setShowInvoicingModal(false);
      setFileList(null);
    } catch (err) {
      setShowError(true);
      setIsLoading(false);
      message.error(err.message);
    }
  };

  const readyToSend = fileList && !showError;

  if (!config.featureFlags?.DRIVER_INVOICING_ENEABLED) return null;

  return (
    <>
      <InvoicingLink />

      {successModalVisible ? (
        <SuccessModal visible={successModalVisible} setVisible={setSuccessModalVisible} />
      ) : (
        <StyledModal visible={showInvoicingModal} footer={null} onCancel={onCancel}>
          {isLoading && <ModalLoadingOverlay />}

          <h1>Send Driver Invoices</h1>
          <p>
            Please upload the <b>.csv</b> file downloaded from the Driver Invoicing Report for the desired
            invoicing period:
          </p>

          {readyToSend && <Heading>Your invoices are ready to be sent</Heading>}

          {!showError && <FileUpload {...{ fileList, setFileList, setApiPayload, setShowError }} />}

          <ErrorContainer {...{ setFileList, setShowError, showError }} />

          {readyToSend && (
            <StyledButton onClick={sendInvoices} type="primary">
              Send Invoices to drivers
            </StyledButton>
          )}
        </StyledModal>
      )}
    </>
  );
};

export default InvoicingModal;
